module.exports = __webpack_public_path__ + "img/deleteprofile.cf190589.svg";